import React from 'react';

interface NavigationItemProps {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
  counter?: number;
  hasNotification?: boolean;
}

const NavigationItem: React.FC<NavigationItemProps> = ({ 
  label, 
  isActive = false, 
  onClick, 
  counter,
  hasNotification = false 
}) => {
  return (
    <div style={{ padding: '0' }}>
      <div 
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 12px',
          cursor: 'pointer',
          // Tabby navigation: no background, only text color changes
          backgroundColor: 'transparent',
          color: isActive ? '#1A202C' : '#4A5568', // Darker for active, secondary for default
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          borderLeft: isActive ? '2px solid #3ECC71' : '2px solid transparent', // Green indicator for active
          paddingLeft: isActive ? '10px' : '12px' // Adjust padding when border is present
        }}
        onClick={onClick}
      >
        <span style={{
          fontWeight: isActive ? 500 : 400, // Medium for active, regular for default
          fontSize: '14px',
          lineHeight: '20px',
          flex: 1
        }}>
          {label}
        </span>
        
        {/* Counter Badge */}
        {counter && counter > 0 && (
          <div style={{
            backgroundColor: '#3ECC71',
            borderRadius: '10px',
            padding: '2px 6px',
            minWidth: '18px',
            height: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{
              color: 'white',
              fontWeight: 600,
              fontSize: '11px',
              lineHeight: '12px'
            }}>
              {counter}
            </span>
          </div>
        )}
        
        {/* Notification Dot */}
        {hasNotification && !counter && (
          <div style={{
            width: '6px',
            height: '6px',
            backgroundColor: '#EF4444',
            borderRadius: '50%'
          }}></div>
        )}
      </div>
    </div>
  );
};

export default NavigationItem;
